<template>
  <section class="partners background-position-center-top p-0 sm-background-image-none">
    <div class="partners-container">
      <div class="partners-header">
        <span class="partners-label">{{ t('index.partners.label') }}</span>
        <h2 class="partners-title">{{ t('index.partners.title') }}</h2>
      </div>

      <!-- Карусель: показується від 480px -->
      <div class="partners-marquee-wrap">
        <div class="partners-marquee-track">
          <div class="partners-marquee-set">
            <div
              v-for="(partner, index) in partners"
              :key="`a-${index}`"
              class="partner-item"
            >
              <img
                :src="partner.logo"
                :alt="partner.name"
                class="partner-logo"
                width="120"
                height="60"
                loading="lazy"
                decoding="async"
              >
            </div>
          </div>
          <div class="partners-marquee-set">
            <div
              v-for="(partner, index) in partners"
              :key="`b-${index}`"
              class="partner-item"
            >
              <img
                :src="partner.logo"
                :alt="partner.name"
                class="partner-logo"
                width="120"
                height="60"
                loading="lazy"
                decoding="async"
              >
            </div>
          </div>
        </div>
      </div>
      <!-- Вертикальний список для мобілки < 480px -->
      <ul class="partners-list">
        <li
          v-for="(partner, index) in partners"
          :key="index"
          class="partners-list-item"
        >
          <img
            :src="partner.logo"
            :alt="partner.name"
            class="partner-logo"
            width="120"
            height="60"
            loading="lazy"
            decoding="async"
          >
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n()
const partners = computed(() => [
  { name: t('index.partners.partner1Name'), logo: '/assets/images/index/partners/logo-hope-ua.svg' },
  { name: t('index.partners.partner2Name'), logo: '/assets/images/index/partners/logo-hmg.svg' },
  { name: t('index.partners.partner3Name'), logo: '/assets/images/index/partners/logo-no-complex.svg' },
  { name: t('index.partners.partner4Name'), logo: '/assets/images/index/partners/logo-3logo.svg' },
  { name: t('index.partners.partner5Name'), logo: '/assets/images/index/partners/logo-nadiya.svg' }
])
</script>

<style scoped>
.partners {
  max-width: var(--max-width-container);
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

/* background-position-center-top — фон по центру сверху */
.partners.background-position-center-top {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  /* background-image: linear-gradient(180deg, rgba(248, 248, 248, 0.97) 0%, rgba(255, 255, 255, 0.98) 100%); */
}

/* p-0 — обнуление вертикального паддинга секции, отступы внутри контейнера */
.partners.p-0 {
  padding-top: 0;
  padding-bottom: 0;
}

.partners-container {
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 15px 40px 34px 40px;
}

/* sm-background-image-none — на малых экранах без фона */
@media (max-width: 767px) {
  .partners.sm-background-image-none {
    background-image: none !important;
    background-color: #fff;
  }
}

.partners-header {
  text-align: center;
  margin-bottom: 89px;
}

.partners-label {
  display: inline-block;
  font-family: var(--font-inter);
  font-weight: 400;
  font-size: var(--font-size-body);
  color: var(--color-teal);
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.partners-title {
  font-family: var(--font-inter);
  font-weight: 700;
  font-size: 48px;
  line-height: 1.2;
  color: var(--color-dark-blue);
  margin: 0;
}

/* Бесконечная прокрутка влево: логотипы едут влево и появляются справа */
.partners-marquee-wrap {
  position: relative;
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
}

/* Градиенты по краям: эффект ухода в размытость и выхода из неё */
.partners-marquee-wrap::before,
.partners-marquee-wrap::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 120px;
  max-width: 15%;
  z-index: 2;
  pointer-events: none;
}

.partners-marquee-wrap::before {
  left: 0;
  background: linear-gradient(to right, #fff 0%, rgba(255, 255, 255, 0) 100%);
}

.partners-marquee-wrap::after {
  right: 0;
  background: linear-gradient(to left, #fff 0%, rgba(255, 255, 255, 0) 100%);
}

.partners-marquee-track {
  display: flex;
  width: max-content;
  animation: partners-marquee 22s linear infinite;
}

.partners-marquee-track:hover {
  animation-play-state: paused;
}

.partners-marquee-set {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
  flex-shrink: 0;
  padding: 0 30px;
}

@keyframes partners-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.partner-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.partner-logo {
  height: 50px;
  width: auto;
  object-fit: contain;
  padding: 0;
  margin: 0;
}

.partner-logo:hover {
  opacity: 0.85;
}

/* Вертикальний список: тільки для мобілки < 480px */
.partners-list {
  display: none;
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center;
}

.partners-list-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.partners-list-item .partner-logo {
  height: 44px;
}

@media (max-width: 479px) {
  .partners-marquee-wrap {
    display: none;
  }

  .partners-list {
    display: block;
  }
}

@media (max-width: 1400px) {
  .partners-container {
    padding: 80px 60px;
  }

  .partners-marquee-set {
    gap: 50px;
  }
}

@media (max-width: 1199px) {
  .partners-marquee-set {
    gap: 40px;
  }

  .partner-logo {
    height: 45px;
  }
}

@media (max-width: 991px) {
  .partners-container {
    padding: 60px 30px;
  }

  .partners-header {
    margin-bottom: 60px;
  }

  .partners-title {
    font-size: 36px;
  }

  .partners-marquee-set {
    gap: 30px;
    padding: 0 20px;
  }

  .partner-logo {
    height: 50px;
  }

  .partners-marquee-track {
    animation-duration: 18s;
  }
}

@media (max-width: 767px) {
  .partners-container {
    padding: 40px 20px;
  }

  .partners-label {
    font-size: 14px;
  }

  .partners-title {
    font-size: 28px;
  }

  .partners-marquee-set {
    gap: 25px;
    padding: 0 15px;
  }

  .partner-logo {
    height: 45px;
  }

  .partners-marquee-track {
    animation-duration: 16s;
  }
}

@media (max-width: 575px) {
  .partners-title {
    font-size: 34px;
  }

  .partners-marquee-set {
    gap: 20px;
  }

  .partner-logo {
    height: 40px;
  }

  .partners-marquee-track {
    animation-duration: 14s;
  }
}
@media (max-width: 480px) {
  .partners-container {
    padding: 0 20px 0px;
  }
}
</style>

